var render = function render(){
  var _vm$stepComponents;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.hideStepperControls ? _c('b-container', {
    staticStyle: {
      "padding-bottom": "30px"
    }
  }, [_c('b-col', [_c('div', {
    staticClass: "step-indicators"
  }, [_c('span'), _vm._v(" "), _c('b-progress', {
    staticClass: "step-indicators-line",
    attrs: {
      "max": 100
    }
  }, [_c('b-progress-bar', {
    attrs: {
      "variant": "stepper-done",
      "value": _vm.percentCompleted
    }
  }), _vm._v(" "), _c('b-progress-bar', {
    attrs: {
      "variant": "stepper-todo",
      "value": 100 - _vm.percentCompleted
    }
  })], 1), _vm._v(" "), _vm._l(_vm.steps, function (step, index) {
    return _c('div', {
      staticStyle: {
        "z-index": "2"
      }
    }, [_c('div', {
      staticClass: "step-indicator",
      class: {
        'step-indicator-active-step': step < _vm.currentStep,
        'step-indicator-inactive-step': step >= _vm.currentStep
      },
      on: {
        "click": function ($event) {
          return _vm.handleClick(step);
        }
      }
    }, [_vm._v("\n            " + _vm._s(index + 1) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "step-indicators-title",
      on: {
        "click": function ($event) {
          return _vm.handleClick(step);
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.stepLabels[step]) + "\n          ")])]);
  })], 2)])], 1) : _vm._e(), _vm._v(" "), _c('b-container', [_vm.stepsComps && _vm.steps && _vm.stepsComps.length === _vm.steps.length ? _c('div', [_c((_vm$stepComponents = _vm.stepComponents) === null || _vm$stepComponents === void 0 ? void 0 : _vm$stepComponents[_vm.activeStep - 1], {
    tag: "component",
    on: {
      "stepper-change": _vm.changeStep
    }
  })], 1) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }